import { useMutation, useQueryClient } from '@tanstack/react-query';
import { postsKeys } from '@/queries/posts/keys';
import { apiClient } from '@/stores/api/apiClient';
import { postTasksKeys } from './keys';

export function useDeletePostTask() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id }: { id: string; postId: string }) => {
      return apiClient.delete(`/v1/agency_tasks/${id}`);
    },
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({ queryKey: postsKeys.item(variables.postId) });
      queryClient.invalidateQueries({ queryKey: postTasksKeys.all });
    },
  });
}
